import React from 'react';
import './Battle.scss';

export const Battle = ({children}) => <div className="battle">{children}</div>;
